import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { RechargeSansInscriptionService } from './../../../api/recharge-sans-inscription.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-retour',
  templateUrl: './confirm-retour.component.html',
  styleUrls: ['./confirm-retour.component.scss']
})
export class ConfirmRetourComponent implements OnInit {


  isSucceeded : boolean = false;
  isNotSucceeded : boolean = false;
  wait: boolean = false;

  subscription: Subscription;
  stationDetail: any;
  token: any;


  constructor(private rechargeSansInscriptionService: RechargeSansInscriptionService, private router: Router, private snackBar: MatSnackBar, private sanitizer: DomSanitizer) 
  { this.getInfoRecharge() }

  ngOnInit(): void {
  }

  StartCharge() {
    this.wait = true;
    let body = {token: this.token, action: "Start"}
    this.rechargeSansInscriptionService.postRemoteRecharge(body).subscribe(
      data => {
        this.wait = false;
        console.log(data)
        this.sucessSnackBarDone(data.message)
      },
      err => {
        console.log(err)
        this.errorSnackBarError(err.error.message)
      });
  }

  StopCharge() {
    this.wait = true;
    let body = {token: this.token, action: "Finish"}
    this.rechargeSansInscriptionService.postRemoteRecharge(body).subscribe(
      data => {
        this.wait = false;
        console.log(data)
        this.sucessSnackBarDone(data.message)
      },
      err => {
        console.log(err)
        this.errorSnackBarError(err.error.message)
      });
  }



  sanitizeImageUrl(imageUrl: any): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }



  getInfoRecharge() {
    this.subscription = this.rechargeSansInscriptionService.currentrecharge_info.subscribe(res => {
      console.log(res);
      if (res) {
        this.stationDetail = res.station
        this.token = res.token
      }
    })
  }



  sucessSnackBarDone(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 50000,
    });
  }


  errorSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 50000,
    });
  }
  


}
